import {
	Typography,
	Card,
	Box,
	Container,
	Grid,
	Paper,
	Button,
} from '@mui/material';
import React from 'react';
import Image1 from '../images/pexels-cup.jpeg';
import '../styles/home.css';
import { Link } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';



import ContentContainer from './ContentContainer';
import Footer from './Foot';

const menuItems = [
	{ label: 'Home', link: '/' },
	{ label: 'About', link: '/about' },
	{ label: 'Contact', link: '/contact' },
];

function Home() {
	const handleClick = () => {
		console.log('Button clicked!!');
	};

	const handleIgIconCliked = () => {
		const url = `https://www.instagram.com/yecocanada/`;
		window.open(url, '_blank');
	};

	const handleFbIconCliked = () => {
		const url = `https://www.facebook.com/yecocanada`;
		window.open(url, '_blank');
	};

	return (
		<div style={{position:"relative"}}>
			<Paper
				elevation={0}
				className="paper "
				square={true}
				justifyContent="center"
				alignItems="center"
				style={{
					// background: '#E5F0FF',
					width: '100%',
					paddingTop: '6.25em',
					height: '100vh',
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						gap: '40px',
						alignItems: 'center',
						width: '90%',
						// height:'80%',
						margin: '0 auto',
						color: 'hsl(0, 0%, 98%)',
						// background: 'hsl(0, 0%, 98%)',
					}}
				>
					<Grid
						className="hero-image"
						container
						variant="outlined"
						// color="primary"
						justifyContent="center"
						alignItems="flex-start"
						flexDirection="column"
						sx={{
							background: 'rgb(0,0,0,.5)',
							width: { sm: 'width:100%', md: '35%', lg: '40%' },
							padding: '12px',

							alignItems: { sm: 'center' },
						}}
					>
						<Grid item>
							<Typography
								variant="h3"
								sx={{
									// color: 'hsl(0, 0%, 98%)',
									fontFamily: 'epilogue',
									zIndex: 2,
								}}
							>
								Welcome
							</Typography>
						</Grid>

						<Grid item>
							<Typography
								variant="h5"
								// color="hsl(0, 0%, 98%)"
								sx={{
									variant: { sm: 'h6', md: 'h5' },
									fontFamily: 'epilogue',
								}}
							>
								to yeco Canada
							</Typography>
						</Grid>

						<Grid item sx={{ marginTop: '.5em', marginBottom: '1em' }}>

						</Grid>
						<Link to="/program" style={{ textDecoration: 'none' }}>
							<Button
								variant="filled"
								href="#more-button"
								onClick={handleClick}
								sx={{ color: '#D9DAFF', background:"#2C73D2" }}
							>
								See our programs
							</Button>
						</Link>
					</Grid>
				</div>
			</Paper>
			<section
				// className='do-section '
				style={{
					width: '100vw',
					height: '50vh',
					background: 'rgb(0,0,255,255,.5)',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					flexDirection: 'column',
				}}
			>
				<Typography
					variant="h5"
					color="hsl(0, 0%, 8%)"
					fontFamily="epilogue"
					borderBottom="1px solid black"
				>
					What we Belive
				</Typography>
				
				<Box
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						paddingTop: '15px',
						width: '250px',
						background: '',
						lineHeight: '1.4',
						position: 'relative',
						left: '2em',
					}}
				>
					<Typography variant="p" color="hsl(0, 0%, 41%)">
						YECO believes in the potential of young people to actively
						participate in community development and leadership activities.
					</Typography>
				</Box>
			</section>
			<Box
				className="do-section "
				sx={{
					height: '60vh',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					textAlign: 'center',
				}}
			>
				<Typography
					color="white"
					variant="h5"
					fontFamily="epilogue"
					fontWeight="500"
					sx={{
						lineHeight: '1.4',
						background: 'rgb(0,0,0,.5)',
						padding: '1em',
					}}
				>
					YECO is committed to helping youth integrate successfully into society
				</Typography>
			</Box>
			<Footer/>
		</div> 
	);
}

export default Home;
